<template>
  <div class="data-panel-v">
    <template v-if="panelViewContainer">
      <component :is="panelViewContainer"
                 v-bind="$attrs"></component>
    </template>
    <template v-else>
      <Hint type="error">
        <span>不支持的视图类型</span>
        <span v-if="type">[{{type}}]</span>
      </Hint>
    </template>
  </div>
</template>

<script>
import TabsPanel from './panel/TabsPanel'
import ListPanel from './panel/ListPanel'
import FormPanel from './panel/FormPanel'
import GroupPanel from './panel/GroupPanel'
import TablePanel from './panel/TablePanel'
import CustomPanel from './panel/CustomPanel'
import Hint from '../Hint'
export default {
  name: 'DataPanelV',
  components: {
    Hint
  },
  props: {
    type: String
  },
  computed: {
    panelViewContainer () {
      switch (this.type) {
        case 'tabs':
          return TabsPanel
        case 'list':
          return ListPanel
        case 'group':
          return GroupPanel
        case 'form':
          return FormPanel
        case 'table':
          return TablePanel
        case 'custom':
          return CustomPanel
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-panel-v {
  height: 100%;
  background-color: #fff;
}
</style>
